import { createContext } from 'react';
import { ICreateAccountContext } from '../interfaces/create-user.interface';

export const CreateAccountContext = createContext({} as ICreateAccountContext);
